export const ErrorConstants = {
    UserCheckMessage: 'Please check your internet connection or try again.',
    GenericErrorMessage: 'Something went wrong. Please check your internet connection or try again.',
};
